<template>
    <div class="carousel">
        <img class="carousel-slide carousel-slide-deactivated" v-for="(image, index) in imgPaths" :key="image.id" :src="getImgUrl(image)" :ref="'slide-'+index">
        <img :src="getImgUrl('belasia-carousel-logo.png')" alt="" class="carousel-logo">
    </div>
</template>

<script>
// var $ = require( "jquery" );

export default({
    // eslint-disable-next-line
    name: 'carousel',
    data: function(){
        return{
            currentSlideIdx: 0,
            imgPathsLen: this.imgPaths.length,
            slideInterval: 5000
        }
    },
    props: {
        imgPaths: Array
    },
    methods: {
        getImgUrl(pet) {
            var images = require.context('../assets/img/', false)
            return images('./' + pet)
        },
        nextSlide(){
            var previousSlide = this.$refs['slide-' + this.currentSlideIdx][0]
            if (previousSlide === undefined) return
            previousSlide.classList.remove('carousel-slide-activated')
            previousSlide.classList.add('carousel-slide-deactivated')

            this.currentSlideIdx++
            if(this.currentSlideIdx >= this.imgPathsLen){
                this.currentSlideIdx = 0
            }

            var currentSlide = this.$refs['slide-' + this.currentSlideIdx][0]
            currentSlide.classList.remove('carousel-slide-deactivated')
            currentSlide.classList.add('carousel-slide-activated')
        }
    },
    mounted(){
        if(this.$route.name == 'Home'){
            window.setInterval(this.nextSlide, this.slideInterval)
            var firstSlide = this.$refs['slide-0'][0]
            firstSlide.classList.remove('carousel-slide-deactivated')
            firstSlide.classList.add('carousel-slide-activated')
        }
    }
})
</script>
